import { FormProvider, useForm } from "react-hook-form";
//import UnForm from "../../../../Components/Form";

export default function CardGestaoDeVisita() {
    const FormMethods = useForm();
    return (

        <FormProvider {...FormMethods}>
            {/* <UnForm handleSubmit={console.log}>
                <div>
                    <h4>Pesquisar Lead</h4>
                    <UnForm.Input
                        name="input"
                    >
                        Pesquisar
                    </UnForm.Input>
                    <button>Pesquisar</button>
                </div>
            </UnForm> */}
       
            <div className="card card-custom p-10">
                <div className="w-100 d-flex justify-content-between align-items-center mb-8">
                    <h4>Criar Visitas</h4>
                    <button
                        className="btn btn-primary col-4"
                    >
                    Pesquisar Lead
                    </button>
                </div>
            </div>
        </FormProvider>
        


    );

}